export default "__VITE_ASSET__DsdHZ_kt__"